import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import Linkable from "component/LinkableComponent/linkable-component";
import { useSelector } from "react-redux";

const ServiceCard = ({ title, description, link, isInternal, serviceAndToolTranslation, isSystem, id}) => {
  
  const dir = useSelector(({theme})=>theme.direction);
  const currentLocale = useSelector(({ theme }) => theme.locale);

  return (
    <div className="col-12 service-item">
      <Linkable
        link={LabelLangString({
          id: "link",
          currentLocale: currentLocale,
          defaultValue: link,
          translations: serviceAndToolTranslation,
        })}
        isInternal={isInternal}
        isSystem={isSystem}
        id={id}
      >
        <div className="services-box">
          <div className="sb-head">
            <h6>
              <LabelLang 
                id={'title'}
                defaultValue={title}
                translations={serviceAndToolTranslation}
              />
            </h6>
            <img
                className={`img1 ${dir === 'rtl' ? 'r-dir' : 'l-dir'}`}
                src={process.env.PUBLIC_URL + "/image/sb.svg"}
              alt="link-img"
              loading="lazy"
            />
          </div>
          <div className="sb-body">
            <p>
              <LabelLang 
                  id={'shortDescription'}
                  defaultValue={description}
                  translations={serviceAndToolTranslation}
              />
            </p>
          </div>
          <img
            width={60}
            height={60}
            className="img1 watermark"
            src={process.env.PUBLIC_URL + "/image/pi.svg"}
            alt="watermark-img"
            loading="lazy"
          />
        </div>
      </Linkable>
    </div>
  );
};

export default ServiceCard;
